import React from 'react';
import { Phone, Mail, MapPin, MessageCircle, Clock} from 'lucide-react';
import SectionHeader from '../componentts/common/SectionHeader';
// import Button from '../componentts/common/Button';

// interface FormData {
//   name: string;
//   email: string;
//   phone: string;
//   service: string;
//   message: string;
// }

const Contact: React.FC = () => {
  // const [formData, setFormData] = useState<FormData>({
  //   name: '',
  //   email: '',
  //   phone: '',
  //   service: '',
  //   message: ''
  // });
  
  // const [ setIsSubmitting] = useState(false);
  // const [ setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };
  
  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
    
  //   // Simulate API call
  //   setTimeout(() => {
  //     console.log('Form submitted:', formData);
  //     setSubmitStatus('success');
  //     setFormData({ name: '', email: '', phone: '', service: '', message: '' });
  //     setIsSubmitting(false);
      
  //     setTimeout(() => setSubmitStatus('idle'), 3000);
  //   }, 1000);
  // };

  const contactInfo = [
    { icon: Phone, title: "Phone", details: "+250 785 950 333", color: "from-blue-500 to-cyan-500" },
    { icon: MessageCircle, title: "WhatsApp", details: "+250 785 950 333", color: "from-green-500 to-emerald-500" },
    { icon: Mail, title: "Email", details: "z2hsupport@gmail.com", color: "from-purple-500 to-pink-500" },
    { icon: MapPin, title: "Location", details: "Kigali, Rwanda", color: "from-red-500 to-orange-500" }
  ];

  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <SectionHeader 
          title="Contact Us" 
          subtitle="We would love to hear from you. Get in touch with us today!"
        />
        
        <div className="grid md:grid-cols-1 gap-12 border-neutral-800">
          {/* Contact Information */}
          <div>
            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
              <div className="space-y-4">
                {contactInfo.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-4 p-4 bg-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                    <div className={`w-12 h-12 bg-gradient-to-r ${item.color} rounded-full flex items-center justify-center`}>
                      <item.icon className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">{item.title}</p>
                      <p className="font-semibold text-gray-800">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Business Hours */}
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 text-white">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="w-8 h-8" />
                <h3 className="text-xl font-bold">Business Hours</h3>
              </div>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span>Monday - Friday:</span>
                  <span className="font-semibold">8:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday:</span>
                  <span className="font-semibold">9:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday:</span>
                  <span className="font-semibold">Closed</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
              {/* <div className="bg-white rounded-2xl shadow-xl p-8">
                <h3 className="text-2xl font-bold mb-6">Send Us a Message</h3>
                
                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
                    Thank you! Your message has been sent successfully. We'll get back to you soon.
                  </div>
                )}
                
                {/* <form onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                      placeholder="John Doe"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                      placeholder="john@example.com"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                      placeholder="+250 XXX XXX XXX"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Service Needed *</label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                    >
                      <option value="">Select a service</option>
                      <option>Website Development</option>
                      <option>Graphic Design</option>
                      <option>IT Training</option>
                      <option>Robotics Training</option>
                      <option>Technical Support</option>
                      <option>Other</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Message *</label>
                    <textarea
                      name="message"
                      rows={5}
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition resize-none"
                      placeholder="Tell us about your project or inquiry..."
                    ></textarea>
                  </div>
                  
                  <Button type="submit" variant="primary" className="w-full justify-center" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>Sending...</>
                    ) : (
                      <>🚀 Send Message <Send className="w-4 h-4" /></>
                    )}
                  </Button>
                </form> */}
              {/* </div>  */}
        </div>
        
        {/* Map Placeholder */}
        <div className="mt-12">
          <div className="bg-gray-200 rounded-2xl h-64 flex items-center justify-center">
            <p className="text-gray-500">📍 Google Maps Integration - Kigali, Rwanda</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;